export enum EvaluationFeedbackRequestType {
  MANAGER_REVIEW = 'MANAGER_REVIEW',
  PEER_REVIEW = 'PEER_REVIEW',
  UPWARD_REVIEW = 'UPWARD_REVIEW'
}